import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { FormDropdown, Header, Form, Segment, Radio } from 'semantic-ui-react';
import {
  getInstallDate,
  getPrimaryWorkerId,
  getSecondaryWorkerIds,
  getInitialDuration,
  getAutonamticRenewal,
  getNextRenewal,
  getErrors,
} from '../reducers/form';
import { getWorkers } from '../reducers/requirements';
import { updateData, fetchFormIfNeeded } from '../actions/form';
import Datepicker from 'common/components/Datepicker';
import Dropdown from 'common/components/Dropdown';
import cx from 'classnames';
import { isFetching } from '../reducers/index';
import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';

export class General extends React.Component {
  constructor(props) {
    super(props);

    this._renderPrimaryWorkersOptions = this._renderPrimaryWorkersOptions.bind(
      this
    );
  }

  componentWillMount() {
    this.props.fetchForm(this.props.contractId);
  }

  _renderPrimaryWorkersOptions() {
    return this.props.workers.map(w => ({
      key: w.id,
      text: w.display_name,
      value: w.id,
    }));
  }

  _renderSecondaryWorkersOptions() {
    return this.props.workers
      .filter(
        w => this.props.workerId === undefined || this.props.workers !== w.id
      )
      .map(w => ({
        key: w.id,
        text: w.display_name,
        value: w.id,
      }));
  }

  render() {
    const {
      installDate,
      workerId,
      secondaryWorkerIds,
      initialDuration,
      automaticRenewal,
      isExisting,
      nextRenewal,
      errors,
    } = this.props;

    const fieldClass = fieldName =>
      cx('field required', {
        error: errors.includes(fieldName),
      });

    const contractDurationOptions = [
      {
        text: `1 an`,
        value: 1,
      },
      {
        text: `2 ans`,
        value: 2,
      },
      {
        text: `3 ans`,
        value: 3,
      },
      {
        text: `4 ans`,
        value: 4,
      },
      {
        text: `5 ans`,
        value: 5,
      },
    ];

    const itemClassName = value => {
      const active = initialDuration === value;
      return cx('item', {
        active: active,
        selected: active,
      });
    };

    const renderDefault = () => {
      const selectedValue = contractDurationOptions.find(
        r => r.value === initialDuration
      );
      if (selectedValue) {
        return <div className="text">{selectedValue.text}</div>;
      }
      return <div className="default text" />;
    };

    const renderItem = item => (
      <div
        key={item.value}
        data-value={item.value}
        className={itemClassName(item.value)}
      >
        {item.text}
      </div>
    );

    const onDropdownChange = (value, text, choice) => {
      this.props.onInitialDurationChange(parseInt(value, 0));
    };

    const automaticRenewaRadioLabel = () => {
      return automaticRenewal ? 'Désactiver' : 'Activer';
    };

    const bloc1Label = isExisting
      ? '1- Renseigner la date estimée de la prochaine intervention'
      : "1- Renseigner la date estimée d'installation";
    const bloc2Label = isExisting
      ? '2- Définir la date de renouvellement du contrat en cours'
      : '2- Définir la durée initiale du contrat';
    const automaticRenewalLabel = isExisting
      ? 'Tacite reconduction annuelle'
      : 'Tacite reconduction annuelle au terme de la durée initiale';

    if (!this.props.isFetching) {
      return (
        <Segment basic>
          <Segment>
            <Header size="tiny">{bloc1Label}</Header>
            <Form.Group>
              <Form.Field
                required
                width={5}
                className={fieldClass('generalInformations.installDate')}
              >
                <label>Date estimée</label>
                <Datepicker
                  identifier="date"
                  name="installDate"
                  value={installDate}
                  onChange={this.props.updateInstallDate}
                  placeholder="JJ/MM/AAAA"
                />
              </Form.Field>
              <Form.Field
                width={5}
                className={fieldClass('generalInformations.primaryWorkerId')}
              >
                <FormDropdown
                  name="workerId"
                  label="Technicien principal"
                  selection
                  options={this._renderPrimaryWorkersOptions()}
                  value={workerId}
                  onChange={(_, value) =>
                    this.props.updateWorkerId(value.value)
                  }
                />
              </Form.Field>
              <Form.Field
                width={15}
                className={fieldClass('generalInformations.secondaryWorkerIds')}
              >
                <FormDropdown
                  name="secondaryWorkerIds"
                  label="Techniciens secondaires"
                  selection
                  multiple
                  options={this._renderSecondaryWorkersOptions()}
                  value={secondaryWorkerIds}
                  onChange={(_, value) =>
                    this.props.updateSecondaryWorkerIds(value.value)
                  }
                />
              </Form.Field>
            </Form.Group>
          </Segment>
          <Segment>
            <Header size="tiny">{bloc2Label}</Header>
            <Form.Group widths="equal">
              {isExisting && (
                <Form.Field
                  required
                  className={fieldClass('generalInformations.nextRenewal')}
                >
                  <label>Date du prochain anniversaire du contrat</label>
                  <Datepicker
                    identifier="dateNextRenewal"
                    name="nextRenewal"
                    value={nextRenewal}
                    onChange={this.props.updateNextRenewal}
                    placeholder="JJ/MM/AAAA"
                  />
                </Form.Field>
              )}
              {!isExisting && (
                <Form.Field
                  required
                  className={fieldClass('generalInformations.initialDuration')}
                >
                  <label>Durée initiale</label>
                  <Dropdown
                    name="initialDuration"
                    value={initialDuration}
                    items={contractDurationOptions}
                    renderDefault={renderDefault}
                    renderItem={renderItem}
                    onChange={onDropdownChange}
                  />
                </Form.Field>
              )}
              <Form.Field>
                <label>{automaticRenewalLabel}</label>
                <Radio
                  toggle
                  name="automaticRenewal"
                  label={automaticRenewaRadioLabel()}
                  checked={automaticRenewal}
                  onChange={this.props.updateAutomaticRenewal}
                />
              </Form.Field>
            </Form.Group>
          </Segment>
        </Segment>
      );
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

General.propTypes = {
  installDate: PropTypes.string.isRequired,
  nextRenewal: PropTypes.string,
  updateInstallDate: PropTypes.func.isRequired,
  updateWorkerId: PropTypes.func.isRequired,
  updateSecondaryWorkerIds: PropTypes.func.isRequired,
  initialDuration: PropTypes.number,
  onInitialDurationChange: PropTypes.func.isRequired,
  automaticRenewal: PropTypes.bool.isRequired,
  updateAutomaticRenewal: PropTypes.func.isRequired,
  secondaryWorkerIds: PropTypes.array,
  fetchForm: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  installDate: getInstallDate(state),
  nextRenewal: getNextRenewal(state),
  workers: getWorkers(state),
  workerId: getPrimaryWorkerId(state),
  secondaryWorkerIds: getSecondaryWorkerIds(state),
  initialDuration: getInitialDuration(state),
  automaticRenewal: getAutonamticRenewal(state),
  errors: getErrors(state),
  isFetching: isFetching(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(id)),
  updateInstallDate: date =>
    dispatch(
      updateData(
        'generalInformations.installDate',
        moment(date.date).format(DATE_FORMAT)
      )
    ),
  updateNextRenewal: date =>
    dispatch(
      updateData(
        'generalInformations.nextRenewal',
        moment(date.date).format(DATE_FORMAT)
      )
    ),
  updateWorkerId: id =>
    dispatch(updateData('generalInformations.primaryWorkerId', id)),
  updateSecondaryWorkerIds: ids =>
    dispatch(updateData('generalInformations.secondaryWorkerIds', ids)),
  onInitialDurationChange: value =>
    dispatch(updateData('generalInformations.initialDuration', value)),
  updateAutomaticRenewal: (_, value) =>
    dispatch(updateData('generalInformations.automaticRenewal', value.checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(General);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/organize/components/General.js